import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Pagination,
} from "@mui/material";

import { Chip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CustomCardForDashboard from "../../Global_Component/customModuleComponent";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import { Person } from "@mui/icons-material";
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import OutboxOutlinedIcon from '@mui/icons-material/OutboxOutlined';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import EmployyeDetail from "../../Hala_india_Dashboard/Master_Admin_Portal/EmployeeWorkingDetail"
const dataUser = [
  {
    id: 1,
    firstName: "Omar",
    lastName: "Qureshi",
    role: "AUDIT",
    login: "15:00 am",
    logOut: "18:30 pm",
    hours: "3 h 30 m",
  },
  {
    id: 2,
    firstName: "Fatima",
    lastName: "Farooq",
    role: "SHARIA",
    login: "9:00 am",
    logOut: "14:00 pm",
    hours: "5 h 0 m",
  },
  {
    id: 3,
    firstName: "Amin",
    lastName: "Sheikh",
    role: "SHARIA",
    login: "14:30 am",
    logOut: "18:30 pm",
    hours: "4 h 0 m",
  },
  {
    id: 4,
    firstName: "Ayesha",
    lastName: "Ahmed",
    role: "SHARIA",
    login: "14:30 am",
    logOut: "15:30 pm",
    hours: "1 h 0 m",
  },
  {
    id: 5,
    firstName: "Omar",
    lastName: "Ansari",
    role: "PREAUDIT",
    login: "11:00 am",
    logOut: "15:00 pm",
    hours: "4 h 0 m",
  },
  {
    id: 6,
    firstName: "Omar",
    lastName: "Farooq",
    role: "PREAUDIT",
    login: "14:00 am",
    logOut: "18:00 pm",
    hours: "4 h 0 m",
  },
  {
    id: 7,
    firstName: "Zayn",
    lastName: "Ahmed",
    role: "AUDIT",
    login: "12:00 am",
    logOut: "14:30 pm",
    hours: "2 h 30 m",
  },
  {
    id: 8,
    firstName: "Amin",
    lastName: "Qureshi",
    role: "PREAUDIT",
    login: "12:00 am",
    logOut: "18:30 pm",
    hours: "6 h 30 m",
  },
  {
    id: 9,
    firstName: "Ali",
    lastName: "Ansari",
    role: "CRM",
    login: "16:30 am",
    logOut: "17:30 pm",
    hours: "1 h 0 m",
  },
  {
    id: 10,
    firstName: "Amin",
    lastName: "Ansari",
    role: "PREAUDIT",
    login: "10:30 am",
    logOut: "14:00 pm",
    hours: "3 h 30 m",
  },
];

const data = [
  { department: "CRM", achieved: 20, target: 40, color: "#EAE2F8" },
  { department: "R&D Pre audit", achieved: 5, target: 30, color: "#F8E2E7" },
  { department: "Finance", achieved: 12, target: 40, color: "#FFE8E8" },
  { department: "Audit", achieved: 20, target: 40, color: "#E8F8F1" },
  { department: "R&D Post audit", achieved: 2, target: 40, color: "#FFF4E5" },
  { department: "Shariah", achieved: 35, target: 40, color: "#E3F2FF" },
];

const ProfileView = () => {
  return (
    <Box sx={{ height: "100%", overflowY: "auto", p: 3 ,bgcolor:"#EDF4F8"}}>
     
      <Grid sm={12}>
        <Grid container spacing={1.5}>
        

          <Grid item xs={12} sm={6} md={3} >
            <CustomCardForDashboard
            lightTheme={'#E6F1FB'}
            darkTheme={'#0072DA'}
              title="New Leads"
              value="256"
              subtitle="45 % ↑"
              icon={<PersonIcon fontSize="medium" />}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomCardForDashboard
            lightTheme={'#EDEBF7'}
            darkTheme={'#8E7AF1'}
              title="Application"
              value="256"
              subtitle="12 % ↑"
              icon={<FolderOpenOutlinedIcon fontSize="medium" />}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomCardForDashboard
             lightTheme={'#E6F4F2'}
             darkTheme={'#008F78'}
              title="Approved Application"
              value="256"
              subtitle="45 % ↑"
              icon={<TaskOutlinedIcon fontSize="medium" />}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomCardForDashboard
             lightTheme={"#FDF2F2"}
             darkTheme={"#F49B68"}
              title="Allocated to Members"
              value="256"
              subtitle="45 % ↑"
              icon={<OutboxOutlinedIcon fontSize="medium" />}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid container sm={12}  sx={{ my: 2 ,display:"flex",alignItems:"flex-start",justifyContent:"flex-start"}}  spacing={1}>
        <Grid item sm={8}>
          
         <EmployyeDetail/>
          {/* Pagination */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <Pagination
              count={4}
              page={1}
              variant="outlined"
              shape="rounded"
              sx={{
                button: {
                  fontSize: "14px",
                  color: "#495057",
                  "&.Mui-selected": {
                    backgroundColor: "green",
                    color: "white",
                  },
                },
              }}
            />
          </Box>
        </Grid>
        <Grid item sm={4} sx={{p:0,}}>
          <Box
            sx={{
              maxWidth: "400px",
             
              padding: "10px",
              background: "#F9FAFC",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                marginBottom: "16px",
                fontWeight: "500",
                fontSize: "18px",
              }}
            >
              Department wise targets
            </Typography>

            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{
                background: "#FFF",
                padding: "10px",
                borderRadius: "8px",
                marginBottom: "20px",
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Month
              </Typography>
              <Select value="July 2024" variant="standard" disableUnderline>
                <MenuItem value="July 2024">July 2024</MenuItem>
              </Select>
            </Grid>

            {data.map((item, index) => (
              <Grid
                container
                alignItems="center"
                key={index}
                sx={{
                  marginBottom: "10px",
                  padding: "10px",
                  background: "#FFF",
                  borderRadius: "8px",
                }}
              >
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#333",
                      textAlign: "center",

                      bgcolor: `${item.color}`,
                    }}
                  >
                    {item.department}
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      height: "8px",
                      background: "#F0F0F0",
                      borderRadius: "4px",
                      marginLeft: 2,
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "8px",
                        width: `${(item.achieved / item.target) * 100}%`,
                        background: "green",
                        borderRadius: "4px",
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "right",
                      color: "#555",
                    }}
                  >
                    {item.achieved}/{item.target}
                  </Typography>
                </Grid>
              </Grid>
            ))}

            <Typography
              sx={{
                textAlign: "center",
                fontSize: "12px",
                color: "#777",
                marginTop: "20px",
                marginBottom: "10px",
              }}
            >
              View complete reports of employees log in activity and work
            </Typography>

            <Button
              fullWidth
              variant="contained"
              sx={{
                background: "#008060",
                color: "#FFF",
                textTransform: "none",
                fontWeight: "500",
                fontSize: "14px",
                borderRadius: "8px",
                "&:hover": { background: "#00674A" },
              }}
            >
              Go to reports
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProfileView;
